"use client";

import React from "react";
import ModalStepperExample from "@/examples/modals/ModalStepperExample";

export default function ModalStepperPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalStepperExample />
    </div>
  );
}
